interface HeaderProps {
  dots: ('active' | 'done' | '')[];
}

export function Header({ dots }: HeaderProps) {
  return (
    <header className="header">
      <div className="header-brand">
        <div className="logo">AI</div>
        <div>
          <div className="brand-name">AIOps &amp; Observability</div>
          <div className="brand-sub">SPLUNK ONBOARDING PORTAL · PLATFORM-SPLUNK-HCS-GLB</div>
        </div>
      </div>
      <div className="sdots" aria-label="Progress through onboarding steps">
        {dots.map((s, i) => (
          <div key={i} className={`sd ${s}`} aria-current={s === 'active' ? 'step' : undefined} />
        ))}
      </div>
    </header>
  );
}
